/**
 * @typedef {Object} ValidationResult
 * @property {String[]} errors
 * @property {boolean} valid
 */

export default class ChangePassword {
  _oldPassword = undefined;
  _newPassword = undefined;
  _validations = [
    v => (!!v.new && v.new.length > 0) || "New password cannot be empty",
    v => (!!v.old && v.old.length > 0) || "Old password cannot be empty",
    v =>
      /^((?!.*[\s])(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-!@#$%^&_*]).{8,16})/.test(v.new) ||
      "Password must have between 8 and 16 characters and it must contain at least: a capital letter, a number and a symbol (!@#$%^&_*)",
    v => v.new != v.old || "New password must be different from the old one"
  ];

  /**
   * Create a new change password data object
   * @public @static
   *
   * @param {String} oldPassword 
   * @param {String} newPassword 
   */
  static create(oldPassword = undefined, newPassword = undefined) {
    const passwordData = new ChangePassword();

    passwordData.oldPassword = oldPassword;
    passwordData.newPassword = newPassword;

    return passwordData;
  }

  // Getters and setters

  /**
   * Returns a data model for the new password
   *
   * @readonly
   * @memberof ChangePassword
   */
  get passwordDataObject () { return { oldPassword: this._oldPassword, newPassword: this._newPassword }; }
  get oldPassword () { return this._oldPassword; }
  get newPassword () { return this._newPassword; }

  set oldPassword (oldPassword) { this._oldPassword = oldPassword; }
  set newPassword (newPassword) { this._newPassword = newPassword; }

  // Public methods

  /**
   * @returns {ValidationResult} 
   */
  validate () {
    const valid = this._validations
      .map(validator => validator({ new: this._newPassword, old: this._oldPassword }))
      .filter(value => typeof value != "boolean");

    return { errors: valid, valid: valid.length == 0 };
  }
}
